module.exports = __webpack_public_path__ + "assets/4cd1d586b76d4fa736b1d07a174f3e44.png";